export enum ColumnToNotDisplay {
   NotDisplay  = 'graphs'
}
